module.exports = __webpack_public_path__ + "img/figma.d997cc2a.png";